module.exports = {
      id: "icon-wire-transfer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-wire-transfer",
      toString: function () {
        return this.url;
      }
    }